import { Stack, Typography } from '@mui/material';
import FlexBox from '@/components/FlexBox';

const DashboardSectionContainer = ({ sectionTitle, isMobile, children }: { sectionTitle?: string; isMobile: boolean; children: JSX.Element }) => {
  return (
    <Stack
      style={{
        flex: 1,
        padding: isMobile ? '20px' : '24px',
        borderRadius: '8px',
        backgroundColor: 'white',
        overflow: 'hidden'
      }}
    >
      {sectionTitle ? (
        <Typography variant="h4" marginBottom={'20px'}>
          {sectionTitle}
        </Typography>
      ) : (
        ''
      )}
      <FlexBox
        style={{
          flexDirection: 'column',
          flex: '1'
        }}
      >
        {children}
      </FlexBox>
    </Stack>
  );
};

export default DashboardSectionContainer;
